import {
    ALPHABANK, MTS, SAMOLET, SBER, YANDER_GO, AVITO_TECH, VK, YANDEX_CLOUD,
    OKKO, USERGATE, S7,
    TISHINA, CIFROVOJ_OKEAN, PRODUCT_LAB, COMNEWS, RSPECTR, ICT2GO, ICTONLINE, IB_BANK, 
    KOMYUTERRA, CISOCLUB, CDO2DAY, SOVETNIK, BANZAJ, PRO, INTERFAKS, RB, SILVER_RAIN, ECHO_MOOSE,
    TECHPROSVET
} from '../../consts/parthner-logos';

const CREATORS = [
    ALPHABANK, MTS, SAMOLET, SBER,
    YANDER_GO, AVITO_TECH, VK, YANDEX_CLOUD,
];

const DELEGATES = [
    OKKO, USERGATE, S7
]

const INFOPARTNERS = [
    PRODUCT_LAB, TISHINA, CIFROVOJ_OKEAN, PRO,
    INTERFAKS, RB, COMNEWS, RSPECTR,
    ICT2GO, ICTONLINE, IB_BANK, KOMYUTERRA,
    CISOCLUB, CDO2DAY, SOVETNIK, BANZAJ,
    SILVER_RAIN, ECHO_MOOSE, TECHPROSVET
]

export { CREATORS, DELEGATES, INFOPARTNERS }
